import * as z from "zod/v4";

const LocationMappingInputSchema_ = z.object({
  locationId: z.bigint(),
  externalLocationId: z.string(),
  locationName: z.string(),
});

export const saveLocationMappings = {
  name: "saveLocationMappings" as const,
  input: z.object({ mappings: z.array(LocationMappingInputSchema_) }),
  output: z.object({ success: z.boolean() }),
};
